<script>
  import { BasicDropdown } from "@urbaninstitute/dataviz-components";
  import ButtonGroup from "./ButtonGroup.svelte";
  import { createData } from "$utils/data.svelte.js";
  import { onMount } from "svelte";
  import Chart from "./Chart.svelte";
  import { slide } from "svelte/transition";
  import { tool_title, instructional_text } from "$utils/consts.js";
  import { active } from "d3";

  const toolData = createData();

  onMount(() => {
    toolData.fetchData();
  });

  //$inspect("chart", toolData.chartData);
</script>

<div class="container">
  <div class="side-by-side">
    <h3 class="override">{tool_title}</h3>
    <p>{instructional_text}</p>
    <div class="controls-box">
      <div class="selectors">
        <BasicDropdown
          data={toolData.dropdownData}
          id="program-selection"
          bind:value={toolData.singledOutProgramVariable}
          onchange={() => {
            toolData.selectedProgramVariable = toolData.singledOutProgramVariable;
          }}
          inlineLabel={"Select an individual program"}
          placeholder={"Select an individual program..."}
        />
        <button
          disabled={toolData.selectedProgramVariable === null &&
            toolData.singledOutProgramVariable === null}
          on:click={() => {
            toolData.selectedProgramVariable = null;
            toolData.singledOutProgramVariable = null;
          }}>Clear selection</button
        >
      </div>
      <ButtonGroup
        group_names={["All", "Direct spending", "Tax expenditures"]}
        bind:active_name={toolData.activeCategory}
        onclick={() => {
          toolData.selectedProgramVariable = null;
          toolData.singledOutProgramVariable = null;
        }}
      />
    </div>
    <div class="context-box">
      <h6 class="program-header">{toolData.contentBoxProgramLabel}</h6>
      <p class="small-font">
        {@html toolData.contentBoxText}
      </p>
    </div>
  </div>
  <div class="side-by-side">
    <Chart />
  </div>
</div>

<style>
  .container {
    display: flex;
    gap: var(--spacing-12);
    /*height: 490px;*/
    max-width: 1031px;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 0;
      height: unset;
    }
  }
  .side-by-side {
    flex: 0 1 50%;
  }
  /* h3/lg */
  .container .side-by-side h3.override {
    color: var(--color-gray-shade-darkest, #353535);
    font-family: var(--font-family-sans-alt);
    font-size: var(--font-size-3-5xl);
    font-variant-ligatures: none;
    font-weight: var(--font-weight-bold);
    line-height: 44px;
    text-transform: none;
  }
  .controls-box {
    margin-bottom: var(--spacing-5);
    margin-top: var(--spacing-8);
    .selectors {
      margin-top: var(--spacing-7);
      margin-bottom: var(--spacing-5);
      display: flex;
      justify-content: flex-start;
      gap: 16px;
      button {
        background-color: white;
        color: black;
        text-decoration: underline;
        text-decoration-thickness: 1.5px;
        border: 0;
        font-family: var(--font-family-sans);
        font-size: 14px;
        &:not(:disabled) {
          cursor: pointer;
        }
        &:focus-visible {
          outline: 2px solid var(--color-gray);
        }
      }
    }
  }
  .context-box {
    padding: var(--spacing-7) var(--spacing-10);
    background-color: var(--color-gray-shade-lightest);
    h3.data-takeaway {
      margin: 0;
    }
    h6.program-header {
      color: var(--color-gray-shade-darkest);
      font-size: var(--font-size-xl);
      margin: var(--spacing-2) 0 0 0;
    }
    p.small-font {
      font-size: var(--font-size-small);
      line-height: 21px;
    }
  }
</style>
